import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Platform, Text, View } from "react-native";
import { styledRN } from "../../styled";
import React from "react";
import { InputFocusedContext } from "../../keyboard-hint";
export const SearchResultKeyboardHintContainer = styledRN(View, {
    padding: 5,
    height: 20,
    minWidth: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderColor: "#ccc",
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: 5,
    marginRight: 5,
    flexGrow: 0,
});
const HintText = styledRN(Text, {
    color: "#ccc",
    lineHeight: 10,
    fontSize: 10,
});
export const SearchResultKeyboardHint = React.memo(function SearchResultKeyboardHint(props) {
    const inputFocused = React.useContext(InputFocusedContext);
    if (Platform.OS !== "web") {
        return null;
    }
    return (_jsx(SearchResultKeyboardHintContainer, { children: _jsxs(HintText, { children: [props.showTabHint === true && inputFocused ? "Tab + " : "", props.value, inputFocused && props.value === "1" && props.showTabHint === true
                    ? " / Enter"
                    : ""] }) }));
});
